import { render, staticRenderFns } from "./GlobalListArticleCard.vue?vue&type=template&id=0554d064&name=global-list-article-card&"
import script from "./GlobalListArticleCard.vue?vue&type=script&lang=js&"
export * from "./GlobalListArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports